var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnkDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "237px",
    height: "237px",
    viewBox: "-3.6 -3.6 43.20 43.20",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    stroke: "#000000",
    strokeWidth: 0.00036,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.6,
    y: -3.6,
    width: 43.2,
    height: 43.2,
    rx: 0,
    fill: "#e5e7eb",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "details-line"), /*#__PURE__*/React.createElement("path", {
    d: "M32,6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V8A2,2,0,0,0,32,6Zm0,22H4V8H32Z",
    className: "clr-i-outline clr-i-outline-path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,14H27a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
    className: "clr-i-outline clr-i-outline-path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,18H27a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
    className: "clr-i-outline clr-i-outline-path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,22H19a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
    className: "clr-i-outline clr-i-outline-path-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fillOpacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnkDetails);
export default __webpack_public_path__ + "static/media/bnk-details.2d655b67077bced9a83b95f49c420a8a.svg";
export { ForwardRef as ReactComponent };